
// * FUNCION QUE REMUEVE LOS ACENTOS DE UNA PALABRA.
export const removeAccents = (str = "") => {
  return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
} 